// src/components/Faq.js
import React from "react";
import "../css/okgather1.webflow.css";
import Footer from "./Footer";

const FAQ_ITEMS = [
  {
    question: "How do I join a gathering?",
    answer: "Create a free OkGather account, then browse our event series on the Events page to pick one you like and choose an upcoming date. It only takes a minute to book your spot.",
  },
  {
    question: "What do I do when I arrive? How do I get my 20% off food and drinks?",
    answer: "Just show up at the venue and show your OkGather member profile at the bar - that's how you get 20% off food and drinks.",
  },
  {
    question: "What if I have more questions?",
    answer: (
      <>
        Check your booking details on the Events page first, as most answers are there. If not, feel free to email us at{" "}
        <a href="mailto:info@okgather.com" style={{ color: "#8B5FBF" }}>info@okgather.com</a> and we aim to reply very quickly!
      </>
    ),
  },
];

const Faq = () => {
  return (
    <div className="page-wrapper" style={{ minHeight: "100vh", backgroundColor: "#FAFAFA" }}>
      <main className="main-wrapper">
        <section className="section_hero">
          <div className="padding-global padding-section-large container-large">
            <div className="hero_card is-vertical">
              <div style={{ maxWidth: "480px", margin: "0 auto" }}>
                <h1 style={{ textAlign: "center", marginBottom: "24px", fontSize: "1.75rem" }}>
                  Frequently Asked Questions
                </h1>
                <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
                  {FAQ_ITEMS.map((item) => (
                    <div
                      key={item.question}
                      style={{
                        background: "#fafafa",
                        border: "1px solid #e5e7eb",
                        borderRadius: "12px",
                        padding: "20px 24px",
                      }}
                    >
                      <p style={{ fontWeight: "600", margin: "0 0 8px 0", color: "#1F2937", fontSize: "1.05rem" }}>
                        {item.question}
                      </p>
                      <p style={{ margin: 0, color: "#4B5563", lineHeight: "1.6", fontSize: "1.05rem" }}>
                        {item.answer}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        <Footer />
      </main>
    </div>
  );
};

export default Faq;
